import './scss/main.scss';
import 'bootstrap';
import './javascript/navbar';
import './javascript/downloads'
import '@fancyapps/fancybox';
